

<app-attendance-validate-payroll-code 
  *ngIf="currentUI=='validate-payroll-code'"
  [savedAttendanceHeader]="attendanceHeader"
  (proceed)="onValidatePayrollCodeProceed($event)">
</app-attendance-validate-payroll-code>

<app-attendance-inout 
  *ngIf="currentUI=='validate-attendance-inout'"
  [proceedData]="proceedApiResponse"
  [attendanceHeader]="attendanceHeader"
  (proceed)="onValidateAttendanceInoutProceed()" 
  (back)="onValidateAttendanceInoutBack()">
</app-attendance-inout>

<app-attendance-hour-limit 
  *ngIf="currentUI=='validate-attendance-limit'"
  [proceedData]="proceedApiResponse"
  [attendanceHeader]="attendanceHeader"
  (proceed)="onValidateAttendanceLimitProceed()" 
  (back)="onValidateAttendanceLimitBack()">
</app-attendance-hour-limit>

<app-attendance-data-export 
  *ngIf="currentUI=='attendance-data-export'"
  [proceedData]="proceedApiResponse"
  [attendanceHeader]="attendanceHeader"
  (proceed)="onExportAttendanceProceed()" 
  (back)="onExportAttendanceBack()">
</app-attendance-data-export>

